import Alert from 'common/components/alert/Alert';
import compareAddress from 'common/services/address/compare';
import formatAddress from 'common/services/address/format-address';
import AlertType from 'common/types/AlertType';
import { Fields as AddressFields } from 'domain/components/address/AddressForm';
import initial from 'domain/initial';
import ChsAddress from 'domain/types/ChsAddress';
import DraftApplication from 'domain/types/DraftApplication';
import React from 'react';
import { Col, Form } from 'react-bootstrap';
import { Field, useForm } from 'react-final-form';

interface IRentalUnitAddress {
  data: DraftApplication;
  profileAddress: ChsAddress;
  previousAddresses: Array<ChsAddress> | null;
}

const RentalUnitAddress = (props: IRentalUnitAddress) => {
  // const isPreselected = compareAddress(
  //   props.data.address,
  //   props.profileAddress
  // );
  const allAddresses: Array<ChsAddress> = [];
  allAddresses.push(props.profileAddress);
  if (props.previousAddresses != null) {
    // filter out any previous profile address instances
    allAddresses.push(
      ...props.previousAddresses.filter(
        (address) => !compareAddress(address, props.profileAddress)
      )
    );
  }
  const isPreselected = allAddresses.some((add) =>
    compareAddress(props.data.address, add)
  );

  const form = useForm<DraftApplication>();

  return (
    <>
      <Field name='meta'>
        {({ meta }) => (
          <>
            {meta.error && <Alert type={AlertType.danger}>{meta.error}</Alert>}
          </>
        )}
      </Field>
      <p>
        Please enter the address for the location for your short term rental.
      </p>
      <p style={{ fontWeight: 'bold' }}>
        The applicant must have legal access to the unit.
      </p>
      <Form.Group as={Form.Row} className='flex-nowrap'>
        <Col sm={{ span: 1 }} className='align-self-center auto-width'>
          <Form.Check
            type='radio'
            id='profile-address'
            checked={isPreselected}
            onChange={() => {
              form.change('address', props.profileAddress);
            }}
          />
        </Col>
        <Form.Label column sm='10' htmlFor='profile-address'>
          Use address from profile or previous application
        </Form.Label>
      </Form.Group>
      {isPreselected && (
        <Form.Group as={Form.Row}>
          <Col sm={{ span: 6 }} className='align-self-center'>
            <Form.Control
              as='select'
              onChange={(e) => {
                form.change('address', allAddresses[parseInt(e.target.value)]);
              }}
            >
              {allAddresses.map((a, idx) => (
                <option value={idx} key={idx}>
                  {formatAddress(a)}
                </option>
              ))}
            </Form.Control>
          </Col>
        </Form.Group>
      )}

      <hr />
      <Form.Group as={Form.Row} className='flex-nowrap'>
        <Col sm={{ span: 1 }} className='align-self-center auto-width'>
          <Form.Check
            type='radio'
            id='new-address'
            checked={!isPreselected}
            onChange={() => {
              form.change('address', initial.address());
            }}
          />
        </Col>
        <Form.Label column sm='10' htmlFor='new-address'>
          Use new address
        </Form.Label>
      </Form.Group>
      {!isPreselected && (
        <AddressFields values={props.data.address} prefix='address.' />
      )}
    </>
  );
};

export default RentalUnitAddress;
